module.exports = __webpack_public_path__ + "static/media/28ft_circle_solid.21f18a17.png";